import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import Drawer from '../../../../../../../components/Drawer'
import Button from '../../../../../../../components/Button'
import AddProductBulkContent from './AddProductBulkContent'

import useManageFormsDrawer from '../../../../../../../hooks/formHooks/useManageFormsDrawer'

import { ADD_PRODUCTS_BULK } from '../../../../../../../constants/forms'

import useStyles from './styles'

const AddProductBulk = ({ addedProducts, onProductsAdd, isDisabled }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const { isFormOpen, openDrawerForm, handleFormClose } = useManageFormsDrawer({
    formName: ADD_PRODUCTS_BULK
  })

  const handleProductsAdd = useCallback(
    newProducts => {
      onProductsAdd(newProducts)
      handleFormClose()
    },
    [onProductsAdd, handleFormClose]
  )

  return (
    <>
      <Button type="button" disabled={isDisabled} onClick={openDrawerForm} isSmall={true}>
        {t('Bulk add products')}
      </Button>
      <Drawer
        isWideDrawer={true}
        title={t('Bulk add products')}
        description={t('The selected date period will determine inventory availability for the filtered product list.')}
        isOpen={isFormOpen}
        onClose={handleFormClose}
        contentClassName={classes.addProductBulkDrawer}
      >
        <AddProductBulkContent addedProducts={addedProducts} onProductsAdd={handleProductsAdd} />
      </Drawer>
    </>
  )
}

AddProductBulk.propTypes = {
  addedProducts: PropTypes.array,
  onProductsAdd: PropTypes.func
}

export default AddProductBulk
